export default __webpack_public_path__ + "static/media/CYT.3bd525ce.png";